import { render, staticRenderFns } from "./ComboBox.vue?vue&type=template&id=2bdbed64&"
import script from "./ComboBox.vue?vue&type=script&lang=js&"
export * from "./ComboBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCombobox,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bdbed64')) {
      api.createRecord('2bdbed64', component.options)
    } else {
      api.reload('2bdbed64', component.options)
    }
    module.hot.accept("./ComboBox.vue?vue&type=template&id=2bdbed64&", function () {
      api.rerender('2bdbed64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/ComboBox.vue"
export default component.exports